import { getHowAuctionsWorkUrl } from '@/utils/urls';
import {
    HowToWinLinkLocation,
    useTrackHowToWinClickedAnalytics,
} from '@/utils/amplitude/analytics/howToWin/trackHowToWinClicked.analytics';
import { useCallback } from 'react';

export const useHowToWinBannerCTA = () => {
    const trackHowToWinClicked = useTrackHowToWinClickedAnalytics();

    const onCTAClick = useCallback(() => {
        trackHowToWinClicked(HowToWinLinkLocation.Banner);
    }, [trackHowToWinClicked]);

    return {
        href: getHowAuctionsWorkUrl(),
        onCTAClick,
    };
};
